/**
 * Parse a Box from an IsoView
 *
 * @param view - The IsoView to read data from
 *
 * @returns A parsed Box
 *
 * @group ISOBMFF
 *
 * @beta
 */
export function free(view) {
    return {
        data: view.readData(-1),
    };
}
;
//# sourceMappingURL=free.js.map